import React, { Fragment, useEffect } from "react";
import Header from "../../components/Header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import DmHero from "./components/DmHero";
import DmServices from "./components/DmServices";
import DmWhyChoose from "./components/DmWhyChoose";
import DmProcess from "./components/DmProcess";
import DmTestimonials from "./components/DmTestimonials";
import DmFaq from "./components/DmFaq";
import DmCta from "./components/DmCta";
import "./digital-marketing.css";

const DigitalMarketingPage: React.FC = () => {
  useEffect(() => {
    document.title = "Digital Marketing Services | WebTech Bangalore";

    const description =
      "Grow your business with SEO, PPC, social media, and content marketing. Data-driven digital marketing services by WebTech Bangalore.";
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, []);

  return (
    <Fragment>
      <div className="dm-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <DmHero />
            <DmServices />
            <DmWhyChoose />
            <DmProcess />
            <DmTestimonials />
            <DmFaq />
            <DmCta />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default DigitalMarketingPage;
